import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Grid } from 'react-flexbox-grid';
import Spin from 'antd/lib/spin';

@translate()
export default class NotificationSignOut extends Component {

    renderMessage() {
        const { t, mailName } = this.props;
        switch (mailName) {
            case 'investment-opportunities':
                return <h2>{t('Notifikácie pre nové investičné príležitosti')}</h2>;
            case 'registration-not-complete':
                return <h2>{t('Notifikácie pre nedokončenú registráciu')}</h2>;
            case 'available-investment':
                return <h2>{t('Notifikácie pre voľné prostriedky na investovanie')}</h2>;
            case 'not-investing':
                return <h2>{t('Notifikácie pre žiadne investície')}</h2>;
            case 'loan-request-not-complete':
                return <h2>{t('Notifikácie pre nedokončenú žiadosť o pôžičku')}</h2>;
            default:
                return '';
        }
    };

    render() {
        const { t, isSigningOut } = this.props;

        return (
            <Spin spinning={isSigningOut} size="large">
                <Grid>
                    {this.renderMessage()}
                    {isSigningOut && <p>{t('Odhlasujeme Vás z notifikácii.')}</p>}
                    {!isSigningOut && <p>{t('Boli ste odhlásený z prijímania notifikácie.')}</p>}
                </Grid>
            </Spin>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/signout-notifications/components/NotificationSignOut.js